const sportBannerList = [
    {
        title: 'lbl_sports',
        text: 'lbl_SportsIntro',
        sportIcon: 'icon icon--sport1',
        enterPoint: '#Sports/s=0',
        desktopPNGPath: 'sports/desktop/Sports.png',
        desktopWebPPath: 'sports/desktop/Sports.webp',
        mobilePNGPath: 'sports/mobile/Sports.png',
        mobileWebPPath: 'sports/mobile/Sports.webp',
    },
    {
        title: 'lbl_VirtualSports',
        text: 'lbl_VSIntro',
        sportIcon: 'icon icon--sport18x',
        enterPoint: '#Sports/s=180',
        desktopPNGPath: 'sports/desktop/VirtualSports.png',
        desktopWebPPath: 'sports/desktop/VirtualSports.webp',
        mobilePNGPath: 'sports/mobile/VirtualSports.png',
        mobileWebPPath: 'sports/mobile/VirtualSports.webp',
    },
    {
        title: 'lbl_Esports',
        text: 'lbl_EsportsIntro',
        sportIcon: 'icon icon--gv-esports',
        enterPoint: '#Sports/s=43',
        desktopPNGPath: 'sports/desktop/E-Sports.png',
        desktopWebPPath: 'sports/desktop/E-Sports.webp',
        mobilePNGPath: 'sports/mobile/E-Sports.png',
        mobileWebPPath: 'sports/mobile/E-Sports.webp',
    },
    {
        title: 'lbl_NumberGame',
        text: 'lbl_NGIntro',
        sportIcon: 'icon icon--gv-number-game',
        enterPoint: '#Sports/s=161',
        desktopPNGPath: 'sports/desktop/NumberGame.png',
        desktopWebPPath: 'sports/desktop/NumberGame.webp',
        mobilePNGPath: 'sports/mobile/NumberGame.png',
        mobileWebPPath: 'sports/mobile/NumberGame.webp',
    },
    {
        title: 'lbl_Gaming',
        text: 'lbl_GamingIntro',
        sportIcon: 'icon icon--gv-live-casino',
        enterPoint: '',
        desktopPNGPath: 'sports/desktop/Gaming.png',
        desktopWebPPath: 'sports/desktop/Gaming.webp',
        mobilePNGPath: 'sports/mobile/Gaming.png',
        mobileWebPPath: 'sports/mobile/Gaming.webp',
    },
    {
        title: 'lbl_RNGKeno',
        text: 'lbl_RNGKenoIntro',
        sportIcon: 'icon icon--gv-mini-casino',
        enterPoint: '',
        desktopPNGPath: 'sports/desktop/RNGKeno.png',
        desktopWebPPath: 'sports/desktop/RNGKeno.webp',
        mobilePNGPath: 'sports/mobile/RNGKeno.png',
        mobileWebPPath: 'sports/mobile/RNGKeno.webp',
    },
];

export default sportBannerList;
